import React from "react";

const SidebarHeader = ({ isDarkMode, edgeServerEndpoint, organizationName }) => {
  // Sidebar header is now empty - title moved to TopBar
  return null;
};

export default SidebarHeader;